/* eslint-disable max-len */
import styled from 'styled-components'
import tokens from '../tokens'
import serviceProductConstant from '../../constants/service-product'

const { fonts, colors } = tokens
const {
  serviceProductType: { HC }
} = serviceProductConstant

export const Style = styled.div`
  .container-service-product {
    width: 100%;
    margin-bottom: 50px;
  }
  .content-service-product {
    display: flex;
    flex-direction: column;
    text-align: center;
    padding-top: 120px;
    padding-bottom: 100px;
    margin-left: -80px;
    margin-right: -80px;
    padding-left: 80px;
    padding-right: 80px;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  .title-service-content {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.31px;
    display: ${props => props.display || 'unset'};
    color: ${props => (props.content === HC ? colors['ui-white'] : '#333333')};
    text-align: ${props => props.align || 'unset'};
  }
  .container-product {
    margin-top: 70px;
    display: grid;
    grid-template-columns: auto auto auto auto;
    justify-content: center;
    gap: 20px;
    width: 100%;
  }
  .content-product {
    width: 200px;
    padding: 20px;
    border-radius: 14px;
    background: ${colors['ui-white']};
    text-align: center;
  }
  .title-product {
    margin-top: 10px;
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 14px;
    font-weight: bold;
    font-weight: ${props => props['fontWeight'] || 'regular'};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #333333;
    text-align: ${props => props.align || 'unset'};
  }
  .subtitle-product {
    margin-top: 10px;
    margin-bottom: 10px;
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 13px;
    font-weight: ${props => props['fontWeight'] || 'regular'};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #333333;
    text-align: ${props => props.align || 'unset'};
  }
  .button-detail {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .text-button {
    margin-right: 10px;
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 14px;
    font-weight: bold;
    font-weight: ${props => props['fontWeight'] || 'regular'};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #498fdf;
    text-align: ${props => props.align || 'unset'};
  }
`
